var exports = {
  "V": "ProjectItemSectionContainer__acx99b",
};

module.exports = exports;
